import React, { Fragment, useState } from "react";
import parser from "html-react-parser";

const RadioField = ({
  label,
  name,
  items,
  required,
  onChangeHandler,
  isValid,
  errorMessage,
  description,
  explanation,
  value,
  ...props
}) => {
  return (
    <>
      <div className="tps-form-question">
        <div className="tps-form-label">
          <span
            className={`EditingFormLabel ${required && "tps-field-required"}`}
          >
            {parser(label)}
          </span>
          {!!explanation && explanation !== "" && (
            <div className="fas fa-info-circle tps-form-tip has-tip">
              <div
                className="tooltiptext"
                dangerouslySetInnerHTML={{ __html: explanation }}
              ></div>
            </div>
          )}
        </div>
        <div className="tps-form-input">
          <div className="EditingFormControlNestedControl editing-form-control-nested-control">
            <span className="radio radio-list-vertical">
              {items &&
                items?.map((item, index) => (
                  <Fragment key={index}>
                    {index > 0 && <br />}
                    <input
                      type="radio"
                      id={`${name}${index}`}
                      name={name}
                      value={item.value}
                      className="tps-to-validate"
                      onChange={(event) => onChangeHandler(event)}
                      checked={value === item.value}
                    />
                    <label
                      htmlFor={`${name}${index}`}
                      dangerouslySetInnerHTML={{
                        __html: item.label || item.value,
                      }}
                    ></label>
                  </Fragment>
                ))}
              {!isValid && required && (
                <span className={"EditingFormErrorLabel"}>{errorMessage}</span>
              )}
            </span>
          </div>
          {!!description && description !== "" && (
            <p
              className="tps-form-input-explaination"
              dangerouslySetInnerHTML={{ __html: description }}
            ></p>
          )}
        </div>
      </div>
    </>
  );
};

export default RadioField;
